<template>
    <div class="ur-dropzone-wrapper">
        <!--  -->
        <div class="ur-dropzone__summary">
            <ur-button small class="ur-dropzone__summary__upper-btn" v-if="upperButton" @click="openDirFile"> {{upperButtonLabel}} </ur-button>
            <div class="ur-dropzone__summary__info">
                {{msgTotal}} <span class="filecount">{{dropzoneStatus.fileCount}}</span><template v-if="maxFiles!==1000000&&maxFiles!==-1"></template>
                |
                {{dropzoneStatus.totalFileSize | byteFormat}}<template v-if="fileSizeLimit!==1024*1024*1024*1024&&fileSizeLimit!==-1">/{{dropzoneStatus.totalFileSizeLimit | byteFormat}}</template>
            </div>
        </div>
        
        <div ref="urDropzone" class="ur-dropzone" :class="dropzoneStatus.fileCount===0 ? 'no-border' : ''">
            <div class="ur-dropzone__control" v-show="dropzoneStatus.fileCount>0">
                <div class="ur-dropzone__control__info">
                    <ur-checkbox class="ur-dropzone__control__checkall" small :checked="selectAllChecked" :checked-icon="selectAllCheckedIcon" @input="clickSelectAll"></ur-checkbox>
                    <ur-icon class="ur-dropzone__control__moveup" icon="arrow_up" @click="moveFileList(false)"></ur-icon>
                    <ur-icon class="ur-dropzone__control__movedown" icon="arrow_down" @click="moveFileList(true)"></ur-icon>
                    <ur-icon class="ur-dropzone__control__trash" icon="delete" @click="deleteFiles"></ur-icon>
                </div>
                <div class="ur-dropzone__control__btn-group">
                    <ur-icon v-if="dropzoneStatus.displayFileList" @click="toggleDisplay">collapse_menu</ur-icon>
                    <ur-icon v-else @click="toggleDisplay">expand_menu</ur-icon>
                </div>
            </div>
            <vue-dropzone v-show="dropzoneStatus.displayFileList"
                          class="ur-vue-dropzone"
                          :class="dropzoneStatus.fileCount>0 ? 'get-file' : ''"
                          ref="myVueDropzone"
                          id="dropzone"
                          :destroyDropzone="false"
                          :options="dropzoneOptions"
                          useCustomSlot
                          clickable
                          @vdropzone-file-added="fileAddedEvent"
                          @vdropzone-sending="sendingEvent"
                          @vdropzone-removed-file="removeEvent"
                          @vdropzone-success="successEvent"
                          @vdropzone-complete="completeEvent"
                          @vdropzone-canceled="canceledEvent"
                          @vdropzone-error="errorEvent"
                          @vdropzone-queue-complete = "queueCompleteEvent"
                          @vdropzone-upload-progress="uploadProgress"
            >
                <!-- Empty Message -->
                <ur-icon style="font-size: 18px; vertical-align: text-bottom;">new_file</ur-icon>
                <span>{{msgDropzone}}</span>
            </vue-dropzone>
        </div>
    </div>
</template>

<script>
    import UrCheckbox from '../urCheckbox/urCheckbox'
    import vueDropzone from './vue2Dropzone';
    import Vue from 'vue';
    import {byteFilter} from "../../../filters/numberFilter/urByteFilter";

    const BYTE_TO_MB = 1024 * 1024;

    export default {
        name: 'ur-dropzone',
        components: { vueDropzone, UrCheckbox },
        props: {
            maxFiles: {
                type: [String, Number],
                default: 1000000
            },
            acceptedFiles : {
                type: [String, Array],
                default : ''
            },
            fileSizeLimit: {  // Mega Byte
                type: [String, Number],
                default: 10000,
            },
            upperButton: {
                type: Boolean,
                default: true,
            },
            upperButtonLabel: {
                type: String,
                default: 'Add'
            },
            contextHost: {
                type: String,
                default: ''
            },
            url: {
                type: String,
                default: '/rest/v2/file/upload/chunk'
            },
            authorization:{
                type: String,
                default: ''
            },
            axiosInstance: {
              type: [Function, Object],
              default: () => {}
            },
            msgTotal: {
              type: String,
              default: 'Total'
            },
            msgDropzone: {
                type: String,
                default: 'Files to attach here'
            },
            fileCategoryId: {
                type: Number,
                default: 0
            }
        },
        computed: {
            selectAllChecked() {
                return (this.fileSelected.length > 0);
            },
            selectAllCheckedIcon() {
                return (this.fileSelected.length === this.getFileCount()) ? 'checked' : 'indeterminate';
            }
        },
        filters: {
            byteFormat(value){
                return byteFilter(value);
            }
        },
        data() {
            return {
                fileSelected: [],
                dropzoneStatus: {
                    groupId: '',
                    fileCountLimit: 0,  /* Will be set in created hook */
                    fileCount: 0,
                    fileSize: 0,
                    totalFileSizeLimit: 0, /* Will be set in created hook */
                    totalFileSize: 0,
                    displayFileList: true,
                    sendFlag: false,
                    sendFailed: false
                },
                dropzoneOptions: {
                    url: (this.axiosInstance.defaults.baseURL ? this.axiosInstance.defaults.baseURL : '') + this.url,  // 파일 업로드 REST URL
                    maxFilesize: this.getMaxFileSize(), // 최대 파일 업로드 크기
                    maxFiles: this.getMaxFileCnt(), // 최대 한번에 업로드 할 수 있는 파일 갯수
                    filesizeBase: 1024, // 최대 한번에 업로드 할 수 있는 파일 갯수
                    chunking: true, // chunk upload가 가능 하도록 하는 옵션
                    chunkSize: 900000, // chunk한조각의 용량 (byte단위)
                    retryChunks: true,  // 전송 실패할 경우 재전송 여부
                    retryChunksLimit: 3,   // 전송 실패 시 몇번까지 재 전송 할 것인가
                    acceptedFiles : this.acceptedFiles,  // ?
                    autoProcessQueue: false,  // dropzone에 파일을 추가하자마자 업로드가 되도록 할지 여부 (false : 파일 추가 만으로 업로드 안됨), Manual upload는 아님
                    parallelChunkUploads: false, // chunk조각들을 한번에 업로드 할지 여부 (true로 하면 모든 조각을 동시에 업로드 한다. ex: 한조각당 10M일 때 100M짜리 파일을 올릴 경우 10조각을 동시에 전송)
                    previewTemplate: this.fileTemplate(), // 올려놓은 파일 모양
                    forceChunking: true, // 하나의 chunk사이즈 이하의 파일도 chunk upload로 할지 여부
                    parallelUploads: 20, // 동시에 전송 할 파일의 갯수 // Default : 2
                    headers: {   // ur의 인증과 XSRF Token전송을 위해 헤서에 실어서 보낸다.
                        'Cache-Control': '',
                        'X-Requested-With': '',
                        'authorization': this.axiosInstance.defaults.headers.common['authorization'],
                        'X-XSRF-TOKEN': this.getCookie('XSRF-TOKEN')
                    },
                    chunksUploaded: this.commitChunks  // chunk 조각들이 모두 전송된 후 실행되는 콜백,
                },
            };
        },
        created() {
            this.dropzoneStatus.groupId = this.generateUUID();
            this.dropzoneStatus.fileCountLimit = this.getMaxFileCnt();
            this.dropzoneStatus.totalFileSizeLimit = this.getMaxFileSize();
        },
        methods: {
            getMaxFileSize(){
                if(!this.fileSizeLimit || parseInt(this.fileSizeLimit) === -1){
                    return 1024 * 1024 * BYTE_TO_MB;
                }else{
                    return parseInt(this.fileSizeLimit) * BYTE_TO_MB;
                }
            },
            getMaxFileCnt(){
                if(!this.maxFiles || parseInt(this.maxFiles) === -1){
                    return 1000000;
                }else{
                    return parseInt(this.maxFiles);
                }
            },
            onClickFile(file){
                let fileName = file.name;
                if (this.fileSelected.indexOf(fileName) >= 0) {
                    file.previewElement.classList.remove("ur-dropzone__selected");
                    this.fileSelected.splice(this.fileSelected.indexOf(fileName), 1);
                } else {
                    file.previewElement.classList.add("ur-dropzone__selected");
                    this.fileSelected.push(fileName);
                }
            },
            fileTemplate() {
                return `
                        <div class="ur-dropzone__file" onMouseOver="this.getElementsByClassName('ur-dropzone__file__remove')[0].style.visibility ='visible'"
                                                         onMouseOut="this.getElementsByClassName('ur-dropzone__file__remove')[0].style.visibility ='hidden'"
                        >
                        <div class="ur-dropzone__file__text-wrapper">
                            <div>
                                <div class="ur-dropzone__file__name" data-dz-name style="display: none;"></div>
                            </div>
                        </div>

                        <div class="ur-dropzone__file__progress-bar">
                             <div class="ur-dropzone__file__progress-bar__inner" data-dz-uploadprogress> </div>
                        </div>
                        <div class="ur-dropzone__file__progress-percent"> 0% </div>
                        <div class="ur-dropzone__file__remove" data-dz-remove>
                            <i class="ur-icon ur-icon--line ur-icon--xsmall opus-icon__close">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <rect x="14.3" y="1" width="1.5" height="27.93" transform="translate(-6.2 15) rotate(-45)"></rect>
                                    <rect x="1" y="14.3" width="27.9" height="1.5" transform="translate(-6.2 15) rotate(-45)"></rect>
                                </svg>
                            </i>
                        </div>
                    </div>
                `;
            },
            toggleDisplay() {
                this.dropzoneStatus.displayFileList = !this.dropzoneStatus.displayFileList;
            },
            commitChunks(file, done) {
                let param = {};
                param.uuid = file.upload.uuid;
                param.fileName = file.upload.filename;
                param.totalFileSize = file.size;
                param.totalChunkCount = file.upload.totalChunkCount;
                param.screenId = this.$store.getters.screenId;
                param.groupId = this.dropzoneStatus.groupId;
                param.fileCategoryId = this.fileCategoryId;
                this.axiosInstance.post(this.url+'/commit/', param)
                .then(res => {
                    done();
                    this.$emit('add-upload', file.upload.uuid);
                })
                .catch(function (error) {
                    file.accepted = false;
                });
            },
            getCookie(name) {
                let re = new RegExp(name + '=([^;]+)');
                let value = re.exec(document.cookie);
                return (value != null) ? unescape(value[1]) : null;
            },
            getFileCount() {
                return this.dropzoneStatus.fileCount;
            },
            doUpload() {
                this.dropzoneStatus.sendFlag = true;
                this.dropzoneStatus.sendFailed = false;

                let newFileCnt = 0;
                let manualFileList = [];
                for(let file of this.$refs.myVueDropzone.dropzone.files) {
                    if(!file.manuallyAdded) {
                        newFileCnt++;
                    } else {
                        manualFileList.push(file);
                    }
                }

                if (newFileCnt > 0) {
                    this.$refs.myVueDropzone.processQueue();
                    if (manualFileList.length > 0) {
                        this.processManualFile(manualFileList);
                    }
                } else if (manualFileList.length > 0) {
                    this.$emit('queue-complete', {fileGroupId: manualFileList[0].fileGroupId});
                }
            },
            processManualFile(manualFileList){
                this.axiosInstance.post('/rest/v2/file/' + this.dropzoneStatus.groupId, manualFileList)
            },
            sendingEvent(file, xhr, formData) {
                xhr.withCredentials = true;
                this.$emit('dropzone-sending', xhr, file, formData);
            },
            fileAddedEvent(file) {
                let urCkBoxEx = Vue.extend(UrCheckbox);
                let urCkBox = new urCkBoxEx({
                    propsData: {
                        size: 'small',
                        checked: this.fileSelected,
                        value: file.name
                    },
                });
                let that = this;
                urCkBox.$on('input',function(v){
                    that.onClickFile(file)
                });
                urCkBox.$slots.default = file.name + ' (' + byteFilter(file.size) + ')';
                urCkBox.$mount();
                let labelNode =  file.previewTemplate.getElementsByClassName("ur-dropzone__file__text-wrapper")[0];
                labelNode.parentNode.insertBefore(urCkBox.$el, labelNode);
                file.previewTemplate.addEventListener("click", function(){that.onClickFile(file)});
                // file.previewTemplate
                this.addTooltip(file);
                let dropzoneFiles = this.$refs.myVueDropzone.dropzone.files;
                this.dropzoneStatus.totalFileSize += file.size;

                /* [VALIDATION] 1. Duplicate */
                for (let i = dropzoneFiles.length - 2; i >= 0; i--) {
                    if (dropzoneFiles[i].name === file.name) {
                        this.$emit('file-dupicate');
                        this.$refs.myVueDropzone.removeFile(file);
                        return;
                    }
                }

                /* [VALIDATION] 2. File count limit */
                if(this.dropzoneOptions.maxFiles < this.$refs.myVueDropzone.dropzone.files.length) {
                    this.$refs.myVueDropzone.removeFile(file);
                    this.$emit('file-count-over');
                    return;
                }

                /* [VALIDATION] 3. File size limit */
                if (this.dropzoneOptions.maxFilesize < this.dropzoneStatus.totalFileSize) {
                    this.$emit('file-size-over');
                    this.$refs.myVueDropzone.removeFile(file);
                    return;
                }
                this.$emit('vdropzone-file-added', file);
                this.updateFileCount();
            },
            manuallyAddFile(file) {
                file = {
                    ...file,
                    type: "dummy/text",
                    size: file.fileSize,
                    name: file.fileName
                }
                let url = '';
                this.$refs.myVueDropzone.manuallyAddFile(file, url);
                this.updateFileCount();
            },
            removeEvent(file, error, xhr) {
                this.dropzoneStatus.totalFileSize -= file.size;
                this.updateFileCount();
                this.$emit('remove-file', file);
            },
            removeAllFiles(cancel = true) {
                this.$refs.myVueDropzone.removeAllFiles(cancel);
            },
            successEvent(file, response){
                this.clearFileList();
                this.$emit('success',file, response);
            },
            completeEvent(file){
                //c onsole.log('completeEvent');
                this.$emit('complete', file);
            },
            canceledEvent(file){
                this.dropzoneStatus.sendFailed = true;
                this.$emit('canceled',file);
            },
            errorEvent(file, message, xhr){
                this.dropzoneStatus.sendFailed = true;
                this.$emit('error',file, message, xhr);
            },
            queueCompleteEvent(){
                if(this.dropzoneStatus.sendFlag) {
                    if(this.dropzoneStatus.sendFailed){
                        this.$emit('queue-complete', {fileGroupId : ''});
                    }else{
                        this.$emit('queue-complete', {fileGroupId : this.dropzoneStatus.groupId});
                    }
                }
            },
            updateFileCount() {
                if ('undefined' !== typeof this.$refs.myVueDropzone.dropzone) {
                    let files = this.$refs.myVueDropzone.dropzone.files;
                    this.dropzoneStatus.fileCount = files.length;
                    this.dropzoneStatus.fileSize = this.dropzoneStatus.totalFileSize;
                } else {
                    this.dropzoneStatus.fileCount = 0;
                    this.dropzoneStatus.fileSize = 0;
                }
            },
            generateUUID() {
                let d = new Date().getTime();
                if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                    d += performance.now(); //use high-precision timer if available
                }
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            },
            uploadProgress(file, progress, bytesSent) {
                if (file.previewElement) {
                    file.previewElement.querySelector('.ur-dropzone__file__progress-percent').style.display = 'inline-block';
                    file.previewElement.querySelector('.ur-dropzone__file__progress-bar').style.display = 'inline-block';
                    let percentage = ((bytesSent / file.size)*100) > 100 ? 100 : ((bytesSent / file.size)*100);
                    percentage = percentage.toFixed(1) + '%';
                    file.previewElement.querySelector('[data-dz-uploadprogress]').style.width = percentage;
                    file.previewElement.querySelector('.ur-dropzone__file__progress-percent').textContent = percentage;
                }
            },
            openDirFile() {
                this.$refs.urDropzone.getElementsByClassName("vue-dropzone")[0].click();
            },
            addTooltip(file) {
                if(file.previewElement) {
                    let pe = file.previewElement.querySelector('[data-dz-name]');
                    pe.setAttribute('title', pe.innerText);
                }
            },
            clickSelectAll() {
                let fileCount = this.getFileCount();
                let fileList = document.getElementsByClassName('ur-dropzone__file');
                if (this.fileSelected.length === fileCount) {
                    for(let i = 0; i < fileCount; i++){
                        this.fileSelected.pop();
                    }
                    for(let idx = 0; idx < fileList.length; idx++){
                      fileList[idx].classList.remove('ur-dropzone__selected');
                    }
                } else {
                    this.$refs.myVueDropzone.dropzone.files.forEach(file => {
                        if(this.fileSelected.indexOf(file.name) < 0){
                            this.fileSelected.push(file.name);
                        }
                    })
                  for(let idx = 0; idx < fileList.length; idx++){
                    fileList[idx].classList.add('ur-dropzone__selected');
                  }
                }
            },
            clearFileList(){
                this.removeAllFiles();
                let fileCount = this.fileSelected.length;
                for(let i = 0; i < fileCount; i++){
                    this.fileSelected.pop();
                }
            },
            deleteFile(name){
                let fileCount = this.$refs.myVueDropzone.dropzone.files.length;
                for(let idx = 0; idx < fileCount; idx++){
                    let deleteTarget = this.$refs.myVueDropzone.dropzone.files[idx];
                    if(deleteTarget.name === name){
                        this.$refs.myVueDropzone.removeFile(deleteTarget);
                        break;
                    }
                }
            },
            deleteFiles(){
                for(let idx = (this.fileSelected.length - 1); 0 <= idx; idx--){
                    this.deleteFile(this.fileSelected[idx]);
                    this.fileSelected.pop();
                }
            },
            /*NOSONAR*/moveFileList(direction){
                let fileList = document.getElementsByClassName("ur-dropzone__file");
                // true ↓↓↓↓↓↓, false ↑↑↑↑↑↑
                if(this.fileSelected.length > 0){
                    let copyFileList = [];

                    let moveIdx = [];
                    let unMoveIdx = [];

                    this.fileSelected.forEach(row => {
                        moveIdx.push(this.findTargetIdx(fileList, row));
                    });
                    moveIdx.sort(function (a, b) {
                        return (a === b) ? 0 : (a > b) ? 1 : -1;
                    });
                    let moveSeq = 0;
                    for(let idx = 0; idx < fileList.length; idx++){
                        if(idx === moveIdx[moveSeq]){
                            moveSeq++;
                        }
                        else{
                            unMoveIdx.push(idx);
                        }
                    }

                    let moveToUnder = direction ? (moveIdx[0] + 1) : (moveIdx[0] - 1);
                    let moveToUpper = direction ? (moveIdx[moveIdx.length-1] + 1) : (moveIdx[moveIdx.length-1] - 1);
                    if(moveToUnder < 0 || moveToUpper >= fileList.length){
                        return;
                    }

                    moveSeq = 0;

                    for(let idx = 0; idx < fileList.length; idx++){
                        if(idx === moveIdx[moveSeq]){
                            let toIdx = direction ? (moveIdx[moveSeq] + 1) : (moveIdx[moveSeq] - 1);
                            // copyFileList[toIdx] = Object.assign({}, fileList[idx]);
                            copyFileList[toIdx] = fileList[idx];
                            moveSeq++;
                        }
                    }

                    let unMoveSeq = 0;
                    for(let idx = 0; idx < fileList.length; idx++){
                        if(!copyFileList[idx]){
                            copyFileList[idx] = fileList[unMoveIdx[unMoveSeq]];
                            unMoveSeq++;
                        }
                    }

                    let dzoneParent = document.getElementsByClassName("ur-vue-dropzone")[0];
                    let lastIdx = (copyFileList.length - 1);
                    for(let idx = lastIdx; 0 <= idx ; idx--){
                        dzoneParent.removeChild(fileList[idx]);
                    }

                    for(let idx = 0; idx < copyFileList.length ; idx++){
                        dzoneParent.appendChild(copyFileList[idx]);
                    }
                }
            },
            findTargetIdx(fileList, targetFile){
                let tmpIdx = -1;
                for(let idx = 0; idx < fileList.length; idx++){
                    if(fileList[idx].getElementsByClassName("ur-dropzone__file__name")[0].textContent === targetFile){
                        tmpIdx = idx;
                        break;
                    }
                }
                return tmpIdx;
            }
        }
    };
</script>